($ => {

    "use strict";

    function megaMenu() {
        return document.querySelector(".mega-menu");
    }

    function megaTrigger() {
        return document.querySelector(".btn-mega-menu");
    }

    function setMegaMenuOpen(open) {
        const menu = megaMenu();
        const trigger = megaTrigger();
        if (!menu) {
            return;
        }

        menu.classList.toggle("active", open);
        menu.setAttribute("aria-hidden", open ? "false" : "true");
        document.body.classList.toggle("no-scroll", open);
        trigger?.setAttribute("aria-expanded", open ? "true" : "false");

        if (open) {
            menu.querySelector(".btn-close")?.focus();
            return;
        }

        if (document.activeElement && menu.contains(document.activeElement)) {
            trigger?.focus();
        }
    }

    $(document).on("click", ".btn-mega-menu", function (event) {
        event.preventDefault();
        setMegaMenuOpen(true);
    });

    $(document).on("click", ".mega-menu .btn-close", function (event) {
        event.preventDefault();
        setMegaMenuOpen(false);
    });

    $(document).on("keydown", function (event) {
        if (event.key === "Escape" && megaMenu()?.classList.contains("active")) {
            setMegaMenuOpen(false);
        }
    });

})(jQuery);
